import { getFramework } from '@/framework';
import { getReferenceLinesState } from '../states/reference-lines-state';
import { ReferenceLineHistoryType } from '../types';

export class DeleteReferenceLine {
    constructor(private id: string) {}

    delete(delLineId: string, pushHistory = true) {
        const delLine = getReferenceLinesState(this.id).referenceLines.find(({ id }) => id === delLineId);
        if (!delLine) {
            return;
        }

        getReferenceLinesState(this.id).deleteReferenceLine(delLineId);

        // 写入历史记录
        if (pushHistory) {
            const framework = getFramework(this.id);
            framework.service.history.write({
                type: ReferenceLineHistoryType.DELETE,
                data: {
                    item: delLine,
                },
            });
        }
    }
}
